import { NavLink } from 'react-router-dom';
import { useModules } from './RoleGuard';

export default function BottomNav({ onMenuOpen }) {
  const { hasHH } = useModules();

  const navItems = [
    {
      to: '/dashboard',
      label: 'Home',
      icon: <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
    },
    {
      to: '/clients',
      label: 'Clients',
      icon: <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>,
    },
    ...(hasHH ? [{
      to: '/hh/calendar',
      label: 'Calendar',
      icon: <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
    }] : []),
    {
      to: '/tasks',
      label: 'Tasks',
      icon: <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>,
    },
  ];

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: 'var(--sidebar-bg)',
      borderTop: '0.5px solid var(--sidebar-border)',
      display: 'flex', alignItems: 'stretch',
      height: 60, zIndex: 100,
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}>
      {navItems.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          style={({ isActive }) => ({
            flex: 1, display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            gap: 3, textDecoration: 'none', padding: '8px 0',
            color: isActive ? 'var(--sidebar-text-active)' : 'var(--sidebar-text)',
            transition: 'color 0.15s',
            borderTop: isActive ? '2px solid var(--sidebar-text-active)' : '2px solid transparent',
          })}
        >
          {item.icon}
          <span style={{ fontSize: 10, fontWeight: 500, fontFamily: 'DM Sans, sans-serif' }}>{item.label}</span>
        </NavLink>
      ))}

      {/* More button */}
      <button
        onClick={onMenuOpen}
        style={{
          flex: 1, display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          gap: 3, background: 'none', border: 'none',
          borderTop: '2px solid transparent',
          cursor: 'pointer', padding: '8px 0',
          color: 'var(--sidebar-text)',
          transition: 'color 0.15s',
          fontFamily: 'DM Sans, sans-serif',
        }}
      >
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <line x1="3" y1="12" x2="21" y2="12"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <line x1="3" y1="18" x2="21" y2="18"/>
        </svg>
        <span style={{ fontSize: 10, fontWeight: 500 }}>Menu</span>
      </button>
    </div>
  );
}
